






















import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
export default class SidebarMobileToggle extends Vue {
  @State("mobileMenuOpen") mobileMenuOpen!: boolean;

  title = "Toggle cache navigation";

  get ARIAState() {
    return this.mobileMenuOpen ? "true" : "false";
  }

  toggle() {
    this.$ga.toggle(this.title);
    this.$store.dispatch("toggleMobileMenu", !this.mobileMenuOpen);
  }

  close() {
    if (this.mobileMenuOpen) {
      this.toggle();
    }
  }
}
